import { NavBarProps } from './MediaPackNavBar.model';
import { NavBar } from './components/NavBar';
import { ShareNavBar } from './components/ShareNavBar';

export const MediaPackNavBar: React.FC<NavBarProps> = ({
  activeSection = 0,
  isSharedView,
  sectionsRefs,
  ...props
}) => {
  return isSharedView ? (
    <ShareNavBar
      {...props}
      activeSection={activeSection}
      isSharedView={isSharedView}
      sectionsRefs={sectionsRefs}
    />
  ) : (
    <NavBar {...props} />
  );
};
